import React from 'react';

const PersonCircleFill = ({ color = 'currentColor', size = 20 }: { color?: string; size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20.283 19.932" fill={color}>
    <path d="M19.922 9.97c0 5.499-4.463 9.962-9.961 9.962C4.473 19.932 0 15.469 0 9.97 0 4.482 4.473.01 9.96.01c5.499 0 9.962 4.472 9.962 9.96M4.766 14.454c0 .371.185.635.595.635h9.2c.41 0 .595-.264.595-.635 0-1.094-1.66-3.955-5.195-3.955s-5.195 2.861-5.195 3.955m2.607-7.617c0 1.621 1.162 2.822 2.588 2.832s2.588-1.211 2.588-2.832c0-1.504-1.162-2.754-2.588-2.754s-2.588 1.25-2.588 2.754" />
  </svg>
);

export default PersonCircleFill;
